import CommonAPIService from "./CommonHandler";

export class ZipsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getByZip(zip, router) {
    const url = `/api/zips/?fields=city,county,state&zip=${zip}`;
    return this.CommonAPIService.getCall(url, router);
  }

  addZip(zipData, router) {
    const url = '/api/zips';
    return this.CommonAPIService.postCall(url, zipData, router)
  }

  updateZip(id, zipData, router) {
    const url = `/api/zips/${id}`;
    return this.CommonAPIService.putCall(url, zipData, router);
  }

  removeZip(id, router) {
    const url = `/api/zips/${id}`;
    return this.CommonAPIService.deleteCall(url, router);
  }
}

export default ZipsAPIService;
